import { Modal } from  '../common/modal';
import SignUpSuccessTemplate from './SignUpSuccessModal.html';

export default class SignUpSuccessModal extends Modal {
    constructor() {
        let content = SignUpSuccessTemplate(window.OverDrive.cardSignUpLink);
        let modalContents = {
            classes : ['SignUpSuccessModal'],
            title: html('idcSignInSuccess.success'),
            hiddenTitle: true,
            content
        };
        super(modalContents);
    }
}
